import { hexRGBA } from '../../../../../utilities/colors'
import { palette } from '../../../../styles/colors'

export const resolveSpacing = (config, isFullWindow?: boolean) => {
    const { clubShow, news } = config

    if (clubShow || news) {
        return {
            padding: `16px 24px`,
            margin: 4,
        }
    }

    if (isFullWindow) {
        return {
            padding: `6px 12px`,
        }
    }

    return {
        padding: `8px 16px`,
        marginBottom: 2,
    }
}

export const resolveColors = (
    myColors,
    theirColors,
    config,
    isFullWindow?: boolean,
) => {
    const { clubShow, system, tip, marker, news, me } = config

    if (news) {
        return {
            boxShadow: `${hexRGBA('#333333', 0.1)} 0px 0px 3px 1px inset`,
            backgroundColor: hexRGBA('#333333', 0.05),
            color: palette.backgroundReverse,
        }
    }

    if (clubShow) {
        return {
            boxShadow: `rgba(229, 246, 253, 0.1) 0px 0px 3px 1px inset`,
            backgroundColor: 'rgb(229, 246, 253)',
            color: palette.backgroundReverse,
        }
    }

    if (tip) {
        return {
            color: isFullWindow ? '#FFFFFF' : palette.greenMFC,
        }
    }

    if (marker || system) {
        return {
            color: theirColors?.marker ? theirColors.marker : '#999999',
        }
    }

    if (me) {
        return myColors
    }

    return theirColors
}

export const resolveAlignment = (config) => {
    const { clubShow, system, marker, news, me } = config

    if (clubShow || system || marker || news) {
        return 'center'
    }

    if (me) {
        return 'flex-end'
    }

    return 'flex-start'
}

export const resolveBorderRadius = (config) => {
    const { clubShow, system, marker, news, me } = config

    const base = { borderRadius: 16 }

    if (marker || system) {
        return base
    }

    if (clubShow || news) {
        return {
            borderRadius: 8,
        }
    }

    if (me) {
        return {
            ...base,
            borderBottomRightRadius: 0,
        }
    }

    return {
        ...base,
        borderBottomLeftRadius: 0,
    }
}

export const resolveTimePosition = ({ me }) => {
    if (me) {
        return {
            textAlign: 'right' as const,
        }
    }

    return {
        textAlign: 'left' as const,
    }
}
